var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVaccination(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.27686 11.0132C9.89818 11.0132 10.4019 10.5095 10.4019 9.88818C10.4019 9.26686 9.89818 8.76318 9.27686 8.76318C8.65554 8.76318 8.15186 9.26686 8.15186 9.88818C8.15186 10.5095 8.65554 11.0132 9.27686 11.0132Z",
    fill: "url(#paint0_linear_3239_13538)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.77686 4.26318H4.77686V3.88818C4.77686 3.49036 4.61882 3.10883 4.33752 2.82752C4.05621 2.54622 3.67468 2.38818 3.27686 2.38818C2.87903 2.38818 2.4975 2.54622 2.2162 2.82752C1.93489 3.10883 1.77686 3.49036 1.77686 3.88818V4.26318Z",
    fill: "url(#paint1_linear_3239_13538)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.777 20.7632H9.27696V21.1382C9.27681 21.6924 9.07103 22.2269 8.69946 22.6382H21.277C21.6748 22.6382 22.0563 22.4801 22.3376 22.1988C22.6189 21.9175 22.777 21.536 22.777 21.1382V20.7632Z",
    fill: "url(#paint2_linear_3239_13538)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6494 15.8618L16.1169 16.3906L16.6494 16.9231L17.1782 16.3906L16.9119 16.1281L16.6494 15.8618Z",
    fill: "url(#paint3_linear_3239_13538)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4019 3.13818V3.88818H11.5269C11.6263 3.88818 11.7217 3.92769 11.792 3.99802C11.8623 4.06834 11.9019 4.16373 11.9019 4.26318V5.38818H12.6519V4.26318C12.6519 4.16373 12.6914 4.06834 12.7617 3.99802C12.832 3.92769 12.9274 3.88818 13.0269 3.88818H14.1519V3.13818H13.0269C12.9274 3.13818 12.832 3.09867 12.7617 3.02835C12.6914 2.95802 12.6519 2.86264 12.6519 2.76318V1.63818H11.9019V2.76318C11.9019 2.86264 11.8623 2.95802 11.792 3.02835C11.7217 3.09867 11.6263 3.13818 11.5269 3.13818H10.4019Z",
    fill: "url(#paint4_linear_3239_13538)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9732 16.8744C17.9087 16.8731 17.8445 16.8643 17.782 16.8482L17.1782 17.4519C17.1088 17.522 17.0261 17.5777 16.935 17.6156C16.844 17.6536 16.7463 17.6732 16.6476 17.6732C16.5489 17.6732 16.4512 17.6536 16.3601 17.6156C16.2691 17.5777 16.1864 17.522 16.117 17.4519L14.7932 18.7794L14.2607 18.2469L15.5882 16.9232C15.5181 16.8537 15.4625 16.7711 15.4245 16.68C15.3865 16.5889 15.367 16.4912 15.367 16.3926C15.367 16.2939 15.3865 16.1962 15.4245 16.1051C15.4625 16.014 15.5181 15.9314 15.5882 15.8619L16.192 15.2582C16.1573 15.1314 16.1567 14.9977 16.1903 14.8706C16.2239 14.7435 16.2904 14.6276 16.3832 14.5344L19.0345 11.8832L18.5057 11.3544L19.027 10.8294V3.88818C19.027 3.49036 18.8689 3.10883 18.5876 2.82752C18.3063 2.54622 17.9248 2.38818 17.527 2.38818H14.152C14.3509 2.38818 14.5416 2.4672 14.6823 2.60785C14.8229 2.74851 14.902 2.93927 14.902 3.13818V3.88818C14.902 4.0871 14.8229 4.27786 14.6823 4.41851C14.5416 4.55917 14.3509 4.63818 14.152 4.63818H13.402V5.38818C13.402 5.5871 13.3229 5.77786 13.1823 5.91851C13.0416 6.05917 12.8509 6.13818 12.652 6.13818H11.902C11.7031 6.13818 11.5123 6.05917 11.3716 5.91851C11.231 5.77786 11.152 5.5871 11.152 5.38818V4.63818H10.402C10.2031 4.63818 10.0123 4.55917 9.87163 4.41851C9.73098 4.27786 9.65196 4.0871 9.65196 3.88818V3.13818C9.65196 2.93927 9.73098 2.74851 9.87163 2.60785C10.0123 2.4672 10.2031 2.38818 10.402 2.38818H4.94946C5.32103 2.79944 5.52681 3.33393 5.52696 3.88818V21.1382C5.52696 21.536 5.685 21.9175 5.9663 22.1988C6.24761 22.4801 6.62914 22.6382 7.02696 22.6382C7.42479 22.6382 7.80632 22.4801 8.08762 22.1988C8.36893 21.9175 8.52696 21.536 8.52696 21.1382V20.7632C8.52696 20.5643 8.60598 20.3735 8.74663 20.2329C8.88729 20.0922 9.07805 20.0132 9.27696 20.0132H19.027V16.1357L18.5057 16.6569C18.3641 16.7971 18.1725 16.8754 17.9732 16.8744ZM13.027 7.26318H17.527V8.01318H13.027V7.26318ZM13.027 8.76318H17.527V9.51318H13.027V8.76318ZM13.027 10.2632H17.527V11.0132H13.027V10.2632ZM13.027 11.7632H17.527V12.5132H13.027V11.7632ZM6.62534 11.4789L7.15559 10.9487L7.42071 11.2142L7.71434 10.9206C7.58128 10.7212 7.48795 10.4979 7.43946 10.2632H7.02696V10.6382H6.27696V9.13818H7.02696V9.51318H7.43946C7.48783 9.27844 7.58104 9.05524 7.71396 8.85581L7.42034 8.56218L7.15521 8.82768L6.62496 8.29743L7.68546 7.23656L8.21571 7.76681L7.95059 8.03193L8.24421 8.32556C8.44369 8.19239 8.66704 8.09905 8.90196 8.05068V7.63818H8.52696V6.88818H10.027V7.63818H9.65196V8.05068C9.88672 8.09898 10.1099 8.19219 10.3093 8.32518L10.603 8.03156L10.3378 7.76643L10.8681 7.23618L11.9286 8.29706L11.3983 8.82731L11.1332 8.56181L10.8396 8.85543C10.9727 9.05495 11.066 9.27829 11.1145 9.51318H11.527V9.13818H12.277V10.6382H11.527V10.2632H11.1145C11.0661 10.4979 10.9729 10.7211 10.84 10.9206L11.1336 11.2142L11.3987 10.9487L11.929 11.4789L10.8685 12.5398L10.3382 12.0096L10.6033 11.7444L10.3097 11.4508C10.1102 11.584 9.88688 11.6773 9.65196 11.7257V12.1382H10.027V12.8882H8.52696V12.1382H8.90196V11.7257C8.6672 11.6774 8.44398 11.5842 8.24459 11.4512L7.95096 11.7448L8.21609 12.0099L7.68584 12.5402L6.62534 11.4789ZM13.777 18.8882H7.02696V18.1382H13.777V18.8882ZM13.777 17.3882H7.02696V16.6382H13.777V17.3882ZM13.777 15.8882H7.02696V15.1382H13.777V15.8882ZM13.777 14.3882H7.02696V13.6382H13.777V14.3882Z",
    fill: "url(#paint5_linear_3239_13538)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5056 13.4731L17.9731 14.0056L18.5056 14.5344L17.9731 15.0669L17.4444 14.5344L16.9119 15.0669L17.9731 16.1281L19.0269 15.0744V13.9944L18.5056 13.4731Z",
    fill: "url(#paint6_linear_3239_13538)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0131 12.6783L23.5419 12.1495L20.8906 9.49829L20.3619 10.027L21.1719 10.8408L20.1106 11.902L19.8294 11.6208V11.617L19.0344 10.822L19.0269 10.8295V11.8758L19.0344 11.8833L19.0269 11.8908V15.0745V16.1358L21.1569 14.0058L21.6856 14.5345L22.2181 14.0058L21.4194 13.2108L21.1381 12.9295L22.1994 11.8683L23.0131 12.6783ZM20.0956 14.0058L19.0344 12.9445L19.5631 12.4158L20.6244 13.477L20.0956 14.0058Z",
    fill: "url(#paint7_linear_3239_13538)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3239_13538",
    x1: 8.29311,
    y1: 8.71424,
    x2: 10.5449,
    y2: 10.3538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB64F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2026,
    stopColor: "#D464F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4457,
    stopColor: "#AC64F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#8F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#7D64FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7764FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3239_13538",
    x1: 1.96519,
    y1: 2.3474,
    x2: 3.91413,
    y2: 4.61795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB64F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2026,
    stopColor: "#D464F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4457,
    stopColor: "#AC64F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#8F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#7D64FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7764FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3239_13538",
    x1: 9.58323,
    y1: 20.7224,
    x2: 10.2812,
    y2: 24.5382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB64F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2026,
    stopColor: "#D464F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4457,
    stopColor: "#AC64F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#8F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#7D64FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7764FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3239_13538",
    x1: 16.1836,
    y1: 15.8387,
    x2: 17.2457,
    y2: 16.6121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB64F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2026,
    stopColor: "#D464F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4457,
    stopColor: "#AC64F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#8F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#7D64FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7764FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3239_13538",
    x1: 10.6373,
    y1: 1.55662,
    x2: 14.3902,
    y2: 4.28929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB64F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2026,
    stopColor: "#D464F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4457,
    stopColor: "#AC64F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#8F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#7D64FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7764FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3239_13538",
    x1: 5.8337,
    y1: 1.94773,
    x2: 23.0001,
    y2: 10.6419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB64F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2026,
    stopColor: "#D464F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4457,
    stopColor: "#AC64F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#8F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#7D64FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7764FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3239_13538",
    x1: 17.0446,
    y1: 13.4154,
    x2: 19.4681,
    y2: 14.8211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB64F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2026,
    stopColor: "#D464F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4457,
    stopColor: "#AC64F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#8F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#7D64FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7764FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3239_13538",
    x1: 19.3103,
    y1: 9.35392,
    x2: 24.8625,
    y2: 12.1039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB64F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2026,
    stopColor: "#D464F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4457,
    stopColor: "#AC64F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#8F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#7D64FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7764FB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaccination);
export default __webpack_public_path__ + "static/media/vaccination.320458675e72fa384ef86ed13413265e.svg";
export { ForwardRef as ReactComponent };